(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-featured-products-tabs"] && !window.DesignMode) return;
  try {
    
  class PivotFeaturedProductTabs extends HTMLElement {
    constructor() {
      super();
      this.$splide = this.querySelector('.splide');
      this.$menuItems = this.querySelectorAll('.pvt-product-tabs__menu .pvt-product-tabs__menu-item');
      this.$articles = this.querySelectorAll('.pvt-product-tabs__article');
      this.$buttonNext = this.querySelector('.slider-button.slider-button--next');
      this.$buttonPrev = this.querySelector('.slider-button.slider-button--prev');

      this.initSplide();
      this.initMenu();
      this.initItems();
    }
    initSplide() {
      import('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js').then(() => {
        console.log('Splide', Splide);
        this.splide = new Splide(this.$splide, {
          type: 'fade',
          perPage: 1,
          arrows: false,
          pagination: false,
          breakpoints: {
            750: {
              pagination: true,
            },
          },
        });
        this.splide.mount();
        this.initEvents();
      });
    }
    initMenu() {
      this.$menuItems.forEach((item, idx) => {
        item.addEventListener('click', () => {
          this.splide.go(idx);
          this.$menuItems.forEach((item, idx2) => item.classList.toggle('is-active', idx2 === idx));
        });
      });
      this.$buttonPrev.addEventListener('click', () => {
        this.splide.go('<');
      });
      this.$buttonNext.addEventListener('click', () => {
        this.splide.go('>');
      });
    }
    initEvents() {
      this.splide.on('active', (event) => {
        this.$menuItems.forEach((item, idx) => item.classList.toggle('is-active', idx === event.index));
        if(this.splide.Components.Controller.getPrev() === -1) this.$buttonPrev.classList.add('is-disabled');
        else this.$buttonPrev.classList.remove('is-disabled');
        if(this.splide.Components.Controller.getNext() === -1) this.$buttonNext.classList.add('is-disabled');
        else this.$buttonNext.classList.remove('is-disabled');
      });
    }

    initItems() {
      this.$articles.forEach((article, idx) => {
        const swatchesImages = article.querySelectorAll('.pvt-product-tabs__swatches-images  img');
        const swatchesActions = article.querySelectorAll('.pivot-card__swatches > div');

        swatchesActions.forEach((action, idx2) => {
          action.addEventListener('click', (event) => {
            const trigger = event.target.closest('.pivot-swatch');
            const option = trigger.dataset.optionPosition;
            const value = trigger.dataset.value;
            swatchesImages.forEach((image, idx3) => {
              image.classList.toggle('is-active', image.dataset[option] === value);
            });
            swatchesActions.forEach((action2) => action2.classList.toggle('is-active', action2 === action));
          });
        });
      });
    }
  }
  if (!customElements.get('pvt-product-tabs')) {
    customElements.define('pvt-product-tabs', PivotFeaturedProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
